module.exports = __webpack_public_path__ + "img/medium.a98ef1bb.jpg";